<template>
    <div class="banner">
        <!-- :lazy="true" -->
        <!-- loading="lazy"  -->
        <!-- <img v-if="!bannerList?.length" :src="changeImgHost('https://cach.kaxyx.top/gamecategroyicon/ccbc6dbd-a9a8-47a0-b770-1f5aa8ddba34.png')" /> -->
        <Swiper
            v-if="bannerList?.length"
            effect="creative"
            direction="horizontal"
            :modules="modules"
            :pagination="{ clickable: true }"
            loop
            :creativeEffect="creativeEffect"
            :autoplay="{ delay: 3000 }"
        >
            <swiper-slide v-for="(item, index) in bannerList" :key="index">
                <div class="swiper-item" @click="handleAction(item)">
                    <img :srcset="changeImgHost(item.picture)" />
                    <div class="item-tip" v-html="$t(item.name)"></div>
                </div>
            </swiper-slide>
        </Swiper>
    </div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay, EffectCreative } from 'swiper/modules'
import 'swiper/css'
import 'swiper/scss/pagination'
import 'swiper/scss/effect-creative'
import { checkLogin, changeImgHost } from '@/utils'
import { useRouter } from 'vue-router'
import eventbus from '@/utils/bus'
import { useGame } from '@/hooks/useGame'
import { Log } from '@/api/log'
import { useI18n } from 'vue-i18n'

const modules = [Autoplay, Pagination, EffectCreative]

const bodyDom = document.querySelector('body')
const store = useBaseStore()
const router = useRouter()
const { goGamePage } = useGame()
const i18n = useI18n()

const creativeEffect = {
    prev: {
        shadow: true,
        translate: [0, 0, -400],
    },
    next: {
        shadow: true,
        translate: ['100%', 0, 0],
    },
}
const bannerList = computed(() => store.gameList.banner)

watch(
    bannerList,
    (val) => {
        if (val.length) {
            bodyDom.classList.remove('hide-banner')
        } else {
            bodyDom.classList.add('hide-banner')
        }
    },
    {
        deep: true,
    }
)

const handleAction = async (item) => {
    Log({
        event: `home_${i18n.t(item.name)}`,
    })
    if (item.jump && item.jump !== 'url') {
        try {
            const logined = await checkLogin()
            if (!logined) {
                return
            }
        } catch (e) {
            console.log(e, 'eee')
            return
        }
    }
    switch (item.jump) {
        case 'page':
            router.push({
                path: item.param,
                query: {
                    back: 1,
                },
            })
            break
        case 'activity':
            eventbus.emit('activity', item)
            break
        case 'game':
            goGamePage({ gametag: item.param })
            break
        case 'url':
            window.open(item.param)
            break
        default:
            break
    }
}
</script>
<style lang="scss" scoped>
.banner {
    padding: 20px 15px 15px;
    height: var(--banner-height);
    img {
        width: 100%;
        height: 100%;
    }

    .swiper,
    .swiper-wrapper,
    .swiper-slide {
        width: 100%;
        height: 100%;
        background-color: #232634;
        border-radius: 30px;
        overflow: hidden;
    }
    .swiper-item {
        position: relative;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .item-tip {
            position: absolute;
            top: 26px;
            left: 42px;
            width: 404px;
            height: 135px;
            font-weight: bold;
            font-size: 36px;
            line-height: 48px;
            color: #fff;
        }
    }
    :deep(.swiper-pagination) {
        display: flex;
        align-items: center;
        width: auto;
        height: 28px;
        left: 32px;
        padding: 0 10px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 14px;

        .swiper-pagination-bullet {
            margin: 0 15px;
            width: 8px;
            height: 8px;
            background: rgba(255, 255, 255, 1);
            // border-radius: 50%;

            &.swiper-pagination-bullet-active {
                width: 23px;
                height: 8px;
                background: rgba(255, 255, 255, 0.9);
                border-radius: 4px;
            }
        }
    }
}
.swiper-slide-prev {
    // perspective: ;
    transform: translate(100%, 0, 0);
}
.swiper-slide-next {
    transform: translate(0, 0, -400);
}
.swiper-slide-active {
    transform: translate(0, 0, 0);
}
</style>
